import React from 'react';
import { LucideIcon } from './LucideIcon';

// ── Regra de senha — criar conta (Login2 SignupCard), redefinir senha
// (Login2 ResetPasswordCard) e alterar senha (Perfil AlterarSenha). Pelo
// menos 8 caracteres, 1 maiúscula, 1 minúscula e 1 número. Senha fora da
// regra não segue pro backend (cada submit checa `senhaValida` antes).
export const REQUISITOS_SENHA = [
  { key: 'tamanho',   label: 'Pelo menos 8 caracteres', ok: s => s.length >= 8 },
  { key: 'maiuscula', label: 'Uma letra maiúscula',     ok: s => /\p{Lu}/u.test(s) },
  { key: 'minuscula', label: 'Uma letra minúscula',     ok: s => /\p{Ll}/u.test(s) },
  { key: 'numero',    label: 'Um número',               ok: s => /\d/.test(s) },
];

export const senhaValida = s => REQUISITOS_SENHA.every(r => r.ok(s || ''));

export const MSG_SENHA_INVALIDA = 'A senha precisa ter pelo menos 8 caracteres, com letra maiúscula, letra minúscula e número.';

// Checklist ao vivo embaixo do campo de senha nova — cinza enquanto não
// cumpre, verde quando cumpre.
export function RequisitosSenha({ senha }) {
  const s = senha || '';
  return (
    <ul style={{ listStyle: 'none', margin: '2px 0 0', padding: '0 4px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '3px 12px' }}>
      {REQUISITOS_SENHA.map(r => {
        const ok = r.ok(s);
        return (
          <li key={r.key} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: ok ? '#5f7d1f' : 'var(--gray-500)', fontWeight: ok ? 600 : 400, transition: 'color .15s' }}>
            <LucideIcon name={ok ? 'check-circle' : 'circle'} size={13}/>
            {r.label}
          </li>
        );
      })}
    </ul>
  );
}
